import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { INote, INoteDetail } from '@boma/supplier-portal/shared/entities';

import { IPaginatedResponse } from '@boma/client-shared';

@Injectable({
  providedIn: 'root',
})
export class NotesService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  loadEntityNotes(
    entityId: string,
    guids: string[],
    page: number = 1,
    pageSize: number = 25
  ) {
    return this.httpClient.post<IPaginatedResponse<INoteDetail>>(
      `${this.base}api/v${this.version}/Notes/${entityId}/List`,
      {
        notableIds: guids,
        page: page,
        pageSize: pageSize,
      }
    );
  }
  createNotes(entityId: string, notes: INote[]) {
    return this.httpClient.post<INoteDetail[]>(
      `${this.base}api/v${this.version}/Notes/${entityId}`,
      {
        notes: notes,
      }
    );
  }

  updateNotes(entityId: string, notes: INote[]) {
    return this.httpClient.post<INoteDetail[]>(
      `${this.base}api/v${this.version}/Notes/${entityId}`,
      {
        updates: notes,
      }
    );
  }
}
